// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1lFzx","productName":"Table_productName__y_P1H"};